import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagsTypes } from './types';

export type UseFeatureFlagReturnType =
  | boolean
  | string
  | number
  | object
  | null;

export function useFeatureFlag(
  flag: keyof FlagsTypes
): UseFeatureFlagReturnType {
  const flags = useFlags<FlagsTypes>();
  if (!flags || flags[flag] === null || flags[flag] === undefined) {
    return null;
  }
  return flags[flag];
}
